<template>
  <div>
    <div class="loader d-flex justify-content-center" v-if="item == null">
      <b-spinner :label="$t('common_phrases.loading')"></b-spinner>
    </div>
    <div class="detail-view" v-if="item != null">
      <div class='static-height-content'>
      <h4>
        <b-icon v-if="item.onlineStatus == 'ONLINE'" icon="check-square-fill" scale='1' variant="success"></b-icon>
        <b-icon v-if="item.onlineStatus == 'OFFLINE'" icon="exclamation-square-fill" scale='1' variant="danger"></b-icon>
        <b-icon v-if="item.onlineStatus == 'UNKNOWN'" icon="question-square-fill" scale='1' variant="secondary"></b-icon>
        {{item.uniqueId}}
        <a v-if="$UIPrivilegeU('devices/ssedisplays')" href="#" class="action-link" @click="editDevice" v-b-tooltip :title="$t('map.buttons.edit_device')"><b-icon icon="gear-fill" scale="1.0"></b-icon></a>
      </h4>
      <b-row v-if="this.spatialData == null" class="no_spatial_info">
        <b-col><b-icon icon="exclamation-circle-fill" variant="warning"></b-icon>
        {{$t('map.warnings.location_lack')}}</b-col>
      </b-row>
      
      <div class="attr-table">
        <b-row><b-col cols="4">{{ $t('map.label.name') }}</b-col><b-col>{{name}}</b-col></b-row>
        <b-row><b-col cols="4">{{ $t('map.label.state') }}</b-col><b-col>{{ item.onlineStatus }}</b-col></b-row> 
      </div>
     
      <InfopointScreenshot v-if="this.deviceType == 'infopoint'" :item="item"></InfopointScreenshot>
      <SseDisplayScreenshot v-if="this.deviceType == 'sseDisplay'" :item="item"></SseDisplayScreenshot>

      <div class="buttons">
        <p-button style='float:left;' size="sm" outline @click="sendCaptureRequest" v-b-tooltip :title="$t('button.refresh')"><b-icon icon="arrow-clockwise" scale="1.0"></b-icon></p-button>
        <p-button v-if="$UIPrivilege('content/info')" size="sm" outline @click="addTextAnnouncement" v-b-tooltip :title="$t('map.buttons.add_text_announcement')"><b-icon icon="card-text" scale="1.0"></b-icon></p-button>
        <p-button v-if="$UIPrivilege('content/images')" size="sm" outline @click="addImageAnnouncement" v-b-tooltip :title="$t('map.buttons.add_image_announcement')"><b-icon icon="card-image" scale="1.0"></b-icon></p-button>
      </div>
      <RequestInfo :ok="ok" :error="error" :loader="loader"/>
      </div>

      <div class='fill-and-scroll'>
        <SseDisplayStatus v-if="this.deviceType == 'sseDisplay'" :display="item"></SseDisplayStatus>
        <DeviceOrganizationParameters :display="item" :key="item.deviceId"></DeviceOrganizationParameters>
      </div>
      

    </div>
  </div>
</template>

<script>
import mapstore from '@/store/map/mapstore'
import InfopointScreenshot from '@/components/Devices/Infopoints/InfopointScreenshot'
import SseDisplayScreenshot from '@/components/Devices/SseDisplays/SseDisplayScreenshot'
import SseDisplayStatus from '@/components/Devices/SseDisplays/SseDisplayStatus'
import DeviceOrganizationParameters from '@/components/Devices/DeviceOrganizationParameters'

export default {
  name: 'MapDeviceDetails',
  components: {
    InfopointScreenshot,
    SseDisplayScreenshot,
    SseDisplayStatus,
    DeviceOrganizationParameters
  },
  data: function() {
    return {
      item: null,
      spatialData: null,
      ok: false,
      error: false,
      loader: false,
    }
  },
  props: {
   // msg: String
    itemId: {type: String, default: null}
  },
  beforeCreate: function() {
    if (!this.$store.state.mapstore) {
      this.$store.registerModule("mapstore" , mapstore);
    }
  },
  watch: {
    devicesForTable(newData) {
      let found = null;
        let $vm = this;
        found = newData.find((i)=>{
          try {
            if(i.device != undefined && i.device != null)
              return i.device.deviceId == $vm.$props.itemId;
            else 
              return i.deviceId == $vm.$props.itemId;
              
          } catch(err){return false;}
        });
        this.item = found;
        if(found.spatialData == undefined) {
          this.spatialData = null;
        } else {
          this.spatialData = found.spatialData;
        }
    }
  },
  mounted() {
      this.$store.dispatch('mapstore/getDevicesForTable') /*.then(
      (data) => {
        let found = null;
        let $vm = this;
        found = data.find((i)=>{
          try {
            if(i.device != undefined && i.device != null)
              return i.device.deviceId == $vm.$props.itemId;
            else 
              return i.deviceId == $vm.$props.itemId;
              
          } catch(err){return false;}
          //try{
          //  return i.device.deviceId == $vm.$props.itemId
          //} catch(err) {/*typerä kääntäjä* /}
        });
        this.item = found;
        if(found.spatialData == undefined) {
          this.spatialData = null;
        } else {
          this.spatialData = found.spatialData;
        }
      }).catch(()=>{ 
      /* error hanskaus * /
      }); */
  },
  created: function () {
      if(this.$route.query.uniqueId) {
      this.filter.text = this.$route.query.uniqueId;
    }
  },
  computed: {
    name: function() {
      try {
        if(this.item.name)
          return this.item.name;
        else
          return this.item.device.name;
      } catch(err) {
        return "";
      }
    },
    deviceType: function() {
      try {
        if(this.item.type != undefined && this.item.type != null && this.item.type == 'SSE_DISPLAY')
          return "sseDisplay";
        else
          return "infopoint";
      } catch(err) {
        return "unknown";
      }
    },
    devicesForTable() {
        return this.$store.state.mapstore.devicesForTable
      }
  },
  methods: {
    hideItemDetails: function() {
      this.$emit('hideItemDetails');
    },
    editDevice: function() {
      if(this.deviceType == 'infopoint') {
        this.$router.push({ path: '/devices/infopoints', query: { uniqueId: this.item.uniqueId }});
      } else {
        this.$router.push({ path: '/devices/ssedisplays', query: { deviceId: this.item.deviceId }});
      }
    },
    getInfopointState(item){
      var state = item.device ? item.device.mode : null;

      if(!state || state == 'IN_OPERATION'){
        if(item.status.infopointStatusId == '0'){ 
          state = "UNKNOWN"
        } else {
          if(item.status.timeStamp){
            var now = new Date();
            var sd = Date.parse(item.status.timeStamp);
            var limit = 1000*60*10; //  10 min
            state = (now - sd < limit) ? "ONLINE" : "OFFLINE";
          }
          else {
            state = "OFFLINE";
          }
        }
      }
      return state;
    },
    addTextAnnouncement: function() {
      this.$router.push({ path: '/content/info', query: { targetDevice: this.item.uniqueId,command:"new" }});
    },
    addImageAnnouncement: function() {
      this.$router.push({ path: '/content/images', query: { targetDevice: this.item.uniqueId,command:"new" }});
    },
    sendCaptureRequest() {
      this.ok = this.error = false;
      this.loader = true;
      const self = this;
      this.$store.dispatch('sseDisplay/sendCaptureRequest', this.item.uniqueId);
      setTimeout(() => { self.ok = true; self.loader = false; }, 1000);               
    }
  }
}
</script>


<style scoped lang="scss">

.fill-and-scroll {
    height: calc(95vh - 500px);
    overflow-y: scroll; 
    overflow-x: hidden; 
    max-width: auto;
}

</style>